var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.empty)?_c('div'):_c('div',[_c('Chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }